<template>
  <div>
    <div class="row center-block">
      <div class="col-md-12">
        <div class="box box-primary">
          <form @submit.prevent>
            <div class="box-body">
              <div class="form-group col-md-10">
                <label for="inputName">Name</label>
                <h1 style="margin-top:0px;">
                  <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputName" placeholder="Order Name" v-model="formData.name">
                </h1>                        
              </div>
              <div class="form-group col-md-2">
                <h3 style="margin-top:0px;">
                  <span class="label label-success pull-right">{{ formData.status}}</span>
                </h3>                     
              </div>                                 
              <div class="row">
                <div class="col-md-12">
                  <div class="nav-tabs-custom">
                    <ul class="nav nav-tabs">
                      <li v-bind:class="{ active: tabActive == TAB_GENERAL }"><a href="#tab_1" data-toggle="tab" aria-expanded="true">General Info</a></li>
                      <li v-bind:class="{ active: tabActive == TAB_ITEMS }"><a @click="onClickTabItems()" href="#tab_2" data-toggle="tab" aria-expanded="true">Items</a></li>
                      <li v-bind:class="{ active: tabActive == TAB_PAYMENT }"><a @click="onClickTabPayment()" href="#tab_3" data-toggle="tab" aria-expanded="true">Payment Info</a></li>
                    </ul>
                  </div>
                  <div class="tab-content">
                    <div v-bind:class="{ active: tabActive == TAB_GENERAL }" class="tab-pane" id="tab_1">
                      <div class="box no-border form-horizontal">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputOpeningBalance" class="col-sm-4 control-label">Document Date</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputOpeningBalance" placeholder="" v-model="formData.documentDate">
                              </div>                     
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputCustomer" class="col-sm-4 control-label">Customer</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputCustomer" placeholder="" v-model="formData.customerName" ref="customerName">
                              </div>                     
                            </div>                      
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputProject" class="col-sm-4 control-label">Project</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputProject" placeholder="" v-model="formData.projectName" ref="projectName">
                              </div>                              
                              <!-- <div class="col-sm-8">
                                <select v-model="formData.projectId" class="form-control" :disabled="viewMode == MODE_VIEW ? true : false">
                                  <option v-for="(row, i) in listProject" v-bind:key="i" v-bind:value="row.id">
                                    {{ row.name }}
                                  </option>
                                </select>
                              </div> -->
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputTotalAmount" class="col-sm-4 control-label">Total Amount</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputTotalAmount" placeholder="" v-model="formData.totalAmount">
                              </div>                     
                            </div>                      
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputSession" class="col-sm-4 control-label">Session</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputSession" placeholder="" v-model="formData.sessionName" ref="sessionName">
                              </div>                     
                            </div>                                         
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputTaxAmount" class="col-sm-4 control-label">Tax Amount</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputTaxAmount" placeholder="" v-model="formData.taxAmount">
                              </div>                     
                            </div>                      
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputPOS" class="col-sm-4 control-label">Point of Sales</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputPOS" placeholder="" v-model="formData.pointOfSalesName" ref="pointOfSalesName">
                              </div>                     
                            </div>                                          
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputNetAmount" class="col-sm-4 control-label">Net Amount</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputNetAmount" placeholder="" v-model="formData.totalAmountIncludeTax">
                              </div>                     
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputPaidAmount" class="col-sm-4 control-label">Paid Amount</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputPaidAmount" placeholder="" v-model="formData.paidAmount">
                              </div>                     
                            </div>                                          
                          </div>
                          <div class="col-md-6">
                            <div class="form-group">
                              <label for="inputReturnAmount" class="col-sm-4 control-label">Return Amount</label>
                              <div class="col-md-8">
                                <input type="text" :disabled="viewMode == MODE_VIEW" class="form-control" id="inputReturnAmount" placeholder="" v-model="formData.returnAmount">
                              </div>                     
                            </div>
                          </div>
                        </div>                                                    
                      </div>
                    </div>
                    <div v-bind:class="{ active: tabActive == TAB_ITEMS }" class="tab-pane" id="tab_2">
                      <div class="box no-border">
                        <div class="box-header">
                            <label for="recordPerPageItem" class="col-sm-1 col-md-1 col-lg-1" style="margin-top: 10px; text-align:left">Show</label>
                            <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                              <select @change="changePageSizeItem($event)" ref="recordPerPageItem" class="form-control">
                                <option v-if="inquiryItemParam.pageSize == 5" selected>5</option><option v-else>5</option>
                                <option v-if="inquiryItemParam.pageSize == 10" selected>10</option><option v-else>10</option>
                                <option v-if="inquiryItemParam.pageSize == 20" selected>20</option><option v-else>20</option>
                                <option v-if="inquiryItemParam.pageSize == 50" selected>50</option><option v-else>50</option>
                                <option v-if="inquiryItemParam.pageSize == 100" selected>100</option><option v-else>100</option>
                              </select>
                            </div>          
                            <div class="box-tools">              
                              <button v-on:click="inquiryItem" class="btn btn-warning">Search</button>
                            </div>
                        </div>                                                     
                        <div class="box-body no-padding table-responsive">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th style="width:30px;text-align:right">#</th>
                                <th style="width:85px;text-align:center;">Action</th>
                                <th style="text-align:left;">Product</th>
                                <th style="text-align:center;">Quantity</th>
                                <th style="text-align:left;">Price</th>
                                <th style="text-align:left;">Discount</th>
                                <th style="text-align:right;">Amount</th>
                                <th style="text-align:right;">Tax</th>
                                <th style="text-align:right;">Tax Amount</th>
                                <th style="text-align:right;">Net Amount</th>
                                <th style="text-align:center;">Currency</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, i) in listItem" v-bind:key="i">
                                <td style="width:30px;text-align:right;">{{ startSequenceItem + i + 1}}</td>
                                <td style="width:85px;text-align:center;">
                                  <a href="#" v-on:click="onDisplayItem(row)" ref="displayRow" style="padding-right:5px">
                                    <span class="icon ion-search" data-toggle="tooltip" data-placement="right" title="Display Item"></span>
                                  </a>
                                </td>                                
                                <td style="text-align:left;" nowrap>{{ row.productName }}</td>
                                <td style="text-align:center;">{{ row.quantity }}</td>
                                <td style="text-align:left;">{{ row.price }}</td>
                                <td style="text-align:left;">{{ row.discount }}</td>
                                <td style="text-align:right;">{{ row.amount }}</td>
                                <td style="text-align:right;">{{ row.tax }}</td>
                                <td style="text-align:right;">{{ row.taxAmount }}</td>
                                <td style="text-align:right;">{{ row.amountIncludeTax }}</td>
                                <td style="text-align:center;">{{ row.currencyName }}</td>
                                <td hidden>{{ row.id }}</td>
                                <td hidden>{{ row.orderId }}</td>
                                <td hidden>{{ row.productId }}</td>
                                <td hidden>{{ row.billPlanId }}</td>
                                <td hidden>{{ row.billPlanSeqNo }}</td>
                                <td hidden>{{ row.currenctId }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="box-footer">
                          <div class="form-group">
                            <label style="width:25px;text-align:right;">
                                <a href="#"><i @click="changePageItem(1)" class="icon ion-ios-rewind"></i></a>
                            </label>
                            <label style="width:35px;text-align:center;">
                                <a href="#"><i @click="changePageItem(inquiryItemParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
                            </label>
                            <label>
                                Page
                            </label>
                            <label>
                                <input v-model="inquiryItemParam.CurrentPageNumber" v-on:keyup.enter="gotoPageItem($event)" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
                            </label>
                            <label id="TotalPageText">
                              {{ totalPagesItem }}                
                            </label>
                            <label style="width:35px;text-align:center;">
                                <a href="#"><i @click="changePageItem(inquiryItemParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
                            </label>
                            <label style="width:25px;text-align:left;">
                                <a href="#"><i @click="changePageItem(totalPagesItem)" class="icon ion-ios-fastforward"></i></a>
                            </label>
                          </div>
                        </div>                        
                      </div>
                    </div>
                    <div v-bind:class="{ active: tabActive == TAB_ITEMS }" class="tab-pane" id="tab_3">
                      <div class="box no-border">
                        <div class="box-header">
                            <label for="recordPerPageItem" class="col-sm-1 col-md-1 col-lg-1" style="margin-top: 10px; text-align:left">Show</label>
                            <div class="col-sm-2 col-md-2 col-lg-1" style="padding-left:0px;">
                              <select @change="changePageSizePayment($event)" ref="recordPerPagePayment" class="form-control">
                                <option v-if="inquiryItemParam.pageSize == 5" selected>5</option><option v-else>5</option>
                                <option v-if="inquiryItemParam.pageSize == 10" selected>10</option><option v-else>10</option>
                                <option v-if="inquiryItemParam.pageSize == 20" selected>20</option><option v-else>20</option>
                                <option v-if="inquiryItemParam.pageSize == 50" selected>50</option><option v-else>50</option>
                                <option v-if="inquiryItemParam.pageSize == 100" selected>100</option><option v-else>100</option>
                              </select>
                            </div>          
                            <div class="box-tools">              
                              <button v-on:click="inquiryPayment" class="btn btn-warning">Search</button>
                            </div>
                        </div>                                                     
                        <div class="box-body no-padding table-responsive">
                          <table class="table table-striped">
                            <thead>
                              <tr>
                                <th style="width:30px;text-align:right">#</th>
                                <th style="text-align:left;">Payment Method</th>
                                <th style="text-align:right;">Amount</th>
                                <th style="text-align:left;">Card No</th>
                                <th style="text-align:center;">Currency</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(row, i) in listPayment" v-bind:key="i">
                                <td style="width:30px;text-align:right;">{{ startSequenceItem + i + 1}}</td>                               
                                <td style="text-align:left;" nowrap>{{ row.paymentMethodName }}</td>
                                <td style="text-align:right;">{{ row.amount }}</td>
                                <td style="text-align:left;">{{ row.cardNo }}</td>
                                <td style="text-align:center;">{{ row.currencyName }}</td>
                                <td hidden>{{ row.id }}</td>
                                <td hidden>{{ row.orderId }}</td>
                                <td hidden>{{ row.sessionId }}</td>
                                <td hidden>{{ row.pointOfSalesId }}</td>
                                <td hidden>{{ row.paymentMethodId }}</td>
                                <td hidden>{{ row.currencyId }}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                        <div class="box-footer">
                          <div class="form-group">
                            <label style="width:25px;text-align:right;">
                                <a href="#"><i @click="changePagePayment(1)" class="icon ion-ios-rewind"></i></a>
                            </label>
                            <label style="width:35px;text-align:center;">
                                <a href="#"><i @click="changePagePayment(inquiryPaymentParam.CurrentPageNumber - 1)" class="icon ion-arrow-left-b"></i></a>
                            </label>
                            <label>
                                Page
                            </label>
                            <label>
                                <input v-model="inquiryPaymentParam.CurrentPageNumber" v-on:keyup.enter="gotoPagePayment($event)" class="form-control" id="CurrentPage" style="width:50px;margin-left:5px;margin-right:5px;">
                            </label>
                            <label id="TotalPageText">
                              {{ totalPagesPayment }}                
                            </label>
                            <label style="width:35px;text-align:center;">
                                <a href="#"><i @click="changePagePayment(inquiryPaymentParam.CurrentPageNumber + 1)" class="icon ion-arrow-right-b"></i></a>
                            </label>
                            <label style="width:25px;text-align:left;">
                                <a href="#"><i @click="changePagePayment(totalPagesPayment)" class="icon ion-ios-fastforward"></i></a>
                            </label>
                          </div>
                        </div>                        
                      </div>
                    </div>
                  </div>
                </div>
              </div>                                                                     
              <input type="hidden" class="form-control" v-model="formData.id">
              <input type="hidden" class="form-control" v-model="formData.projectId">
              <input type="hidden" class="form-control" v-model="formData.customerId">
              <input type="hidden" class="form-control" v-model="formData.pointOfSalesId">
              <input type="hidden" class="form-control" v-model="formData.sessionId">
            </div>

            <div class="box-footer">
              <div class="box-tools">
                <button @click="onBack()" class="btn btn-default" style="margin-right:15px;">Back</button>
                <!-- <button @click="onCancel()" class="btn btn-warning">Cancel</button> -->
                <!-- <button v-if="viewMode != MODE_VIEW" @click="onSave()" class="btn btn-info pull-right">Save</button>
                <button v-if="viewMode == MODE_VIEW" @click="onEdit(formData)" class="btn btn-info pull-right">Edit</button>
                <button v-if="viewMode == MODE_VIEW" @click="onCreate()" class="btn btn-info pull-right" style="margin-right:15px;">Create</button> -->
              </div>
            </div>

          </form>
        </div>          
      </div>
    </div>
  </div>  
</template>

<script>
// import $ from 'jquery'
import api from '../../api'
import SweetAlert from 'sweetalert2'
import datepicker from '../../components/widgets/DatePicker'
import config from '../../config'

const MODE_NONE = 'none'
// const MODE_CREATE = 'create'
const MODE_VIEW = 'read'
const MODE_UPDATE = 'update'
const TAB_GENERAL = 'tabGeneral'
const TAB_ITEMS = 'tabItems'
const TAB_PAYMENT = 'tabPayment'

export default {
  name: 'POSOrderForm',
  components: {
    datepicker
  },
  data() {
    return {
      callback: '',
      DATE_FORMAT: config.dateFormat,
      MODE_NONE: MODE_NONE,
      MODE_VIEW: MODE_VIEW,
      MODE_UPDATE: MODE_UPDATE,
      TAB_GENERAL: TAB_GENERAL,
      TAB_ITEMS: TAB_ITEMS,
      TAB_PAYMENT: TAB_PAYMENT,
      viewMode: MODE_NONE,
      formData: {
        id: 0,
        name: '',
        documentData: '',
        customerId: 0,
        customerName: '',
        projectId: 0,
        projectName: '',
        billId: 0,
        totalAmount: 0,
        taxAmount: 0,
        totalAmountIncludeTax: 0,
        paidAmount: 0,
        returnAmount: 0,
        currencyId: 0,
        currencyName: '',
        sessionId: 0,
        sessionName: '',
        pointOfSalesId: 0,
        pointOfSalesName: '',
        status: '',
        noOfPrint: 0
      },
      listItem: null,
      listItemTemp: null,
      totalRowsItem: 0,
      totalPagesItem: 0,
      startSequenceItem: 0,
      inquiryItemParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'DESC',
        SortExpression: 'CreatedDate'
      },
      listPayment: null,
      listPaymentTemp: null,
      totalRowsPayment: 0,
      totalPagesPayment: 0,
      startSequencePayment: 0,
      inquiryPaymentParam: {
        WhereClause: '',
        CurrentPageNumber: 1,
        PageSize: 10,
        SortDirection: 'ASC',
        SortExpression: 'PaymentMethodName'
      },
      tabActive: '',
      listProduct: null,
      listCurrency: null,
      showValidFrom: false,
      originalcallback: ''
    }
  },
  computed: {
  },
  created() {
    this.formData.id = this.$route.params.id
    this.viewMode = this.$route.params.mode
    this.callback = this.$route.params.callback
    this.callbackId = this.$route.params.callbackId
    this.originalcallback = this.$route.params.originalcallback
    this.tabActive = TAB_GENERAL
    this.getDetail()
  },
  mounted() {
    this.$refs.recordPerPageItem.value = this.inquiryItemParam.PageSize
  },
  methods: {
    getDetail() {
      api
        .request('POS', 'get', '/api/Order/GetDetail?Id=' + this.formData.id, null)
        .then(response => {
          var data = response.data
          this.formData = data.entity
        })
        .then(response => {
          this.getProjectName()
          this.getCustomerName()
          this.getSessionName()
          this.getPointOfSalesName()
          this.getCurrencyName()
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getCurrencyName() {
      api
        // .request('Account', 'get', '/api/Currency/InquiryAll', null)
        .request('Account', 'get', '/api/Currency/Inquiry?WhereClause=Id = ' + this.formData.currencyId +
                                 '&PageSize=1&CurrentPageNumber=1&SortDirection=ASC&SortExpression=Id', null)
        .then(response => {
          var data = response.data
          if (data.entity[0]) {
            this.formData.currencyName = data.entity[0].name
            this.$refs.currencyName.value = data.entity[0].name
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getCustomerName() {
      api
        // .request('Account', 'get', '/api/Currency/InquiryAll', null)
        .request('Guest', 'get', '/api/Guest/Inquiry?WhereClause=Id = ' + this.formData.customerId +
                                 '&PageSize=1&CurrentPageNumber=1&SortDirection=ASC&SortExpression=Id', null)
        .then(response => {
          var data = response.data
          if (data.entity[0]) {
            this.formData.customerName = (data.entity[0].firstName + ' ' + data.entity[0].lastName).trim()
            this.$refs.customerName.value = (data.entity[0].firstName + ' ' + data.entity[0].lastName).trim()
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getProjectName() {
      api
        .request('Account', 'get', '/api/Project/Inquiry?WhereClause=Id = ' + this.formData.projectId +
                                 '&PageSize=1&CurrentPageNumber=1&SortDirection=ASC&SortExpression=Id', null)
        // .request('Account', 'get', '/api/Project/Inquiry?', null)
        .then(response => {
          var data = response.data
          if (data.entity[0]) {
            this.formData.projectName = data.entity[0].name
            this.$refs.projectName.value = data.entity[0].name
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getPointOfSalesName() {
      api
        .request('POS', 'get', '/api/POS/Inquiry?WhereClause=Id = ' + this.formData.pointOfSalesId +
                                 '&PageSize=1&CurrentPageNumber=1&SortDirection=ASC&SortExpression=Id', null)
        // .request('POS', 'get', '/api/POS/InquiryAll', null)
        .then(response => {
          var data = response.data
          if (data.entity[0]) {
            this.formData.pointOfSalesName = data.entity[0].name
            this.$refs.pointOfSalesName.value = data.entity[0].name
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getSessionName() {
      api
        .request('POS', 'get', '/api/Session/Inquiry?WhereClause=Id = ' + this.formData.sessionId +
                                 '&PageSize=1&CurrentPageNumber=1&SortDirection=ASC&SortExpression=Id', null)
        // .request('POS', 'get', '/api/POS/InquiryAll', null)
        .then(response => {
          var data = response.data
          if (data.entity[0]) {
            this.formData.sessionName = data.entity[0].name
            this.$refs.sessionName.value = data.entity[0].name
          }
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onBack() {
      let params = {
        mode: MODE_VIEW,
        callbackId: this.callbackId,
        callback: this.originalcallback
      }
      this.$router.push({ name: this.callback, params: params })
      // this.$router.push({ name: 'Order' })
    },
    onClickTabItems() {
      this.inquiryItem()
    },
    inquiryItem() {
      api
        .request('POS', 'get', '/api/Order/GetItem?Id=' + this.formData.id, null)
        .then(response => {
          var data = response.data
          this.listItemTemp = data.entity
          this.totalRowsItem = data.totalRows
          this.totalPagesItem = data.totalPages
          this.$refs.recordPerPageItem.value = this.inquiryItemParam.PageSize

          var arrCurrency = []
          var arrProduct = []
          console.log(this.listItemTemp)
          this.listItemTemp.forEach(itemOrder => {
            arrCurrency.push(itemOrder.currencyId)
            var arrCurrencyUnique = arrCurrency.filter(function(item, index) {
              return arrCurrency.indexOf(item) >= index
            })
            arrCurrency = arrCurrencyUnique

            arrProduct.push(itemOrder.productId)
            var arrProductUnique = arrProduct.filter(function(item, index) {
              return arrProduct.indexOf(item) >= index
            })
            arrProduct = arrProductUnique
          })
          this.getProductName(arrProduct, arrCurrency)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getProductName(arrProduct, arrCurrency) {
      let whereClause = 'id in (' + arrProduct.join(',') + ')'
      console.log(arrProduct)
      api
        .request('Sales', 'get', '/api/Product/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrProduct.length +
                                      '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        .then(response => {
          var data = response.data
          this.listProduct = data.entity

          var productName
          this.listItemTemp.forEach(itemOrder => {
            productName = ''
            this.listProduct.some(function(item, index) {
              if (itemOrder.productId === item.id) {
                productName = item.name
              }
            })
            itemOrder.productName = productName
          })
          this.getCurrencyNameOrderItem(arrCurrency)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    getCurrencyNameOrderItem(arrCurrency) {
      let whereClause = 'id in (' + arrCurrency.join(',') + ')'
      api
        .request('Account', 'get', '/api/Currency/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrCurrency.length +
                                      '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        .then(response => {
          var data = response.data
          this.listCurrency = data.entity

          var currencyName
          this.listItemTemp.forEach(itemOrder => {
            currencyName = ''
            this.listCurrency.some(function(item, index) {
              if (itemOrder.currencyId === item.id) {
                currencyName = item.name
              }
            })
            itemOrder.currencyName = currencyName
          })
          this.listItem = this.listItemTemp
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    changePageSizeItem(evt) {
      this.inquiryItemParam.PageSize = evt.target.value
      this.inquiryItemParam.CurrentPageNumber = 1
      this.startSequenceOrder = (this.inquiryItemParam.CurrentPageNumber - 1) * this.inquiryItemParam.PageSize
      this.inquiryItem()
    },
    gotoPageItem(evt) {
      if (evt.target.value > this.totalPagesItem) {
        this.inquiryItemParam.CurrentPageNumber = this.totalPagesItem
      } else if (evt.target.value < 1) {
        this.inquiryItemParam.CurrentPageNumber = 1
      }
      this.startSequenceOrder = (this.inquiryItemParam.CurrentPageNumber - 1) * this.inquiryItemParam.PageSize
      this.inquiryItem()
    },
    changePageItem(page) {
      if (page < 1) {
        this.inquiryItemParam.CurrentPageNumber = 1
      } else if (page > this.totalPagesItem) {
        this.inquiryItemParam.CurrentPageNumber = this.totalPagesItem
      } else {
        this.inquiryItemParam.CurrentPageNumber = page
      }
      this.startSequence = (this.inquiryItemParam.CurrentPageNumber - 1) * this.inquiryItemParam.PageSize
      this.inquiryItem()
    },
    getCurrencyNameOrderPayment(arrCurrency) {
      let whereClause = whereClause = 'id in (' + arrCurrency.join(',') + ')'

      api
        .request('Account', 'get', '/api/Currency/Inquiry?WhereClause=' + whereClause + '&PageSize=' + arrCurrency.length +
                                      '&CurrentPageNumber=1&SortDirection=ASC&SortExpression=id', null)
        .then(response => {
          var data = response.data
          this.listCurrency = data.entity

          var currencyName
          this.listPaymentTemp.forEach(paymentOrder => {
            currencyName = ''
            this.listCurrency.some(function(item, index) {
              if (paymentOrder.currencyId === item.id) {
                currencyName = item.name
              }
            })
            paymentOrder.currencyName = currencyName
          })
          this.listPayment = this.listPaymentTemp
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    },
    onClickTabPayment() {
      this.inquiryPayment()
    },
    inquiryPayment() {
      api
        .request('POS', 'get', '/api/Order/CashFlow?Id=' + this.formData.id, null)
        .then(response => {
          var data = response.data
          this.listPaymentTemp = data.entity
          this.totalRowsPayment = data.totalRows
          this.totalPagesPayment = data.totalPages
          this.$refs.recordPerPagePayment.value = this.inquiryPaymentParam.PageSize

          var arrCurrency = []
          this.listPaymentTemp.forEach(paymentOrder => {
            arrCurrency.push(paymentOrder.currencyId)
            var arrCurrencyUnique = arrCurrency.filter(function(item, index) {
              return arrCurrency.indexOf(item) >= index
            })
            arrCurrency = arrCurrencyUnique
          })

          this.getCurrencyNameOrderPayment(arrCurrency)
        })
        .catch(error => {
          var message = error.message + ':<br>' + error.response.data.returnMessage.join('<br>')
          SweetAlert.fire('Error', message, 'error')
        })
    }
  }
}
</script>

<style scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
input[type=text], select {
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  border: 1px solid #ccc;
  border-top-style: none;
  border-right-style: none;
  border-left-style: none;
  color: #777;
  margin: 0px;
}
input:focus {
  outline: none;
  border-bottom: 2px solid #337AB7;
}

.q_avatar {
  float: left;
  box-sizing: border-box;
  position: relative;
  text-align: inherit;
}
.q_avatar > img {
  max-height: 90px;
  max-width: 90px;
  margin-bottom: 10px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.4);
  border: none;
}
.q_form_image_controls {
  position: absolute;
  top: 0;
  left: auto;
  bottom: auto;
  right: 0;
  width: 100%;
  color: white;
  background-color: #337AB7;
  opacity: 0;
  transition: opacity ease 400ms;
}
.q_hidden_input_file {
  position: absolute;
  top: 1px;
  opacity: 0;
  width: 100%;
  height: 26px;  
  display: none;
}
.q_form_image_controls > .ion {
  margin: 5px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// POSOrderForm.vue?7e21cfcd